import {
	IonPage,
	IonTitle,
	IonToolbar,
	IonButtons,
	IonButton,
	IonIcon,
	IonMenuButton,
} from "@ionic/react";
import {
	menu,
	arrowBack,
	personCircle,
	informationCircleOutline,
} from "ionicons/icons";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { LOGGED_USER_KEY, SIGNED_IN } from "../../utils/constants";
import UserMenu from "../../components/user-menu";
import HintsModal from "../../components/modals/hints";
import { HintsDef } from "../../components/common/tvm-form/form-definition";
import { LocalizationContext } from "../../App";
import { translate, translateHtml } from "../../utils/helpers";

import "./styles.css";

interface WithHeaderProps {
	className?: string;
	showUser?: boolean;
	showLogo?: boolean;
	title?: string;
	preventGoBack?: boolean;
	titleSize?: TitleSize;
	hintsContent?: HintsDef;
}

export type TitleSize = "small" | "large" | undefined;

const WithHeader: React.FC<WithHeaderProps> = (props): JSX.Element => {
	const {
		showUser = true,
		showLogo = false,
		title,
		preventGoBack = false,
		className,
		titleSize = "large",
		hintsContent,
	} = props;
	const [showUserMenu, setShowUserMenu] = useState(false);
	const [showHintsModal, setShowHintsModal] = useState(false);
	const history = useHistory();
	const { user = null } = JSON.parse(
		localStorage.getItem(LOGGED_USER_KEY) || "{}"
	);
	const locales = useContext(LocalizationContext);

	const handleSignOut = () => {
		//localStorage.removeItem(LOGGED_USER_KEY);
		localStorage.removeItem(SIGNED_IN);
		// TODO: signOut from firebase
		//signOut();
		// history.replace("/signin");
	};

	return (
		<IonPage className={className}>
			<IonToolbar className="app-header">
				<IonButtons slot="start">
					{preventGoBack && (
						<IonMenuButton>
							<IonIcon slot="icon-only" icon={menu}></IonIcon>
						</IonMenuButton>
					)}
					{!preventGoBack && (
						<IonButton onClick={() => history.go(-1)}>
							<IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
						</IonButton>
					)}
					{/* <IonButton>
            <IonIcon slot="icon-only" icon={menu}></IonIcon>
          </IonButton> */}
					{/* <img
            alt="logo"
            style={{ padding: "15px", height: "50px" }}
            src=""
          ></img> */}
				</IonButtons>
				<IonTitle size={titleSize} className={showLogo ? "withLogo" : ""}>
					{showLogo && <img alt="logo" src="/assets/TVM_splash-01.png" />}
					{title || ""}
				</IonTitle>
				<IonButtons slot="end">
					{showUser && user && (
						<>
							<IonTitle size="small" class="user-name">
								{user.displayName}
							</IonTitle>

							<IonButton
								id="user-icon-button"
								onClick={() => setShowUserMenu(!showUserMenu)}
							>
								{user?.photoUrl && (
									<img
										style={{ borderRadius: "50%", width: 22, height: 22 }}
										src={user.photoUrl!}
									/>
								)}
								{!user?.photoUrl && (
									<IonIcon slot="icon-only" icon={personCircle} />
								)}
							</IonButton>
						</>
					)}
					{hintsContent && (
						<>
							<IonButton
								onClick={() => setShowHintsModal(true)}
								id="hint-icon-button"
							>
								<IonIcon
									slot="icon-only"
									icon={informationCircleOutline}
								></IonIcon>
							</IonButton>
							<HintsModal
								visible={showHintsModal}
								title={translate(hintsContent.title || "", locales)}
								hintsContent={translateHtml(hintsContent.htmlDef, locales)}
								onClose={() => setShowHintsModal(false)}
							/>
						</>
					)}
				</IonButtons>

				{
					/*(showUser && user) ||*/
					// true && (
					//   <IonButtons slot="start">
					//     <IonTitle size={titleSize} class="user-name">
					//       {title || ""}
					//     </IonTitle>
					/* <IonButton
              id="user-icon-button"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <IonIcon slot="icon-only" icon={personCircle} />
            </IonButton> */
					// </IonButtons>
					// )
				}
			</IonToolbar>

			{showUserMenu && (
				<div
					className="user-menu__container"
					onClick={() => setShowUserMenu(false)}
				>
					<UserMenu
						visible={showUserMenu}
						name={user?.displayName}
						email={user?.email}
						photoUrl={user?.photoUrl}
						onSignOut={handleSignOut}
					/>
				</div>
			)}

			{props.children}
		</IonPage>
	);
};

export default WithHeader;
